import { ref, watch } from 'vue'
import { Preferences } from '@capacitor/preferences'

export type Theme = 'light' | 'dark'

const currentTheme = ref<Theme>('dark')

export const useTheme = () => {
  const initTheme = async () => {
    const { value } = await Preferences.get({ key: 'theme' })
    const savedTheme = value as Theme
    
    if (savedTheme && ['light', 'dark'].includes(savedTheme)) {
      currentTheme.value = savedTheme
    } else {
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
      currentTheme.value = prefersDark ? 'dark' : 'light'
    }
    
    applyTheme(currentTheme.value)
  }

  const applyTheme = (theme: Theme) => {
    document.body.classList.remove('light', 'dark')
    document.body.classList.add(theme)
  }

  const setTheme = async (theme: Theme) => {
    currentTheme.value = theme
    await Preferences.set({ key: 'theme', value: theme })
    applyTheme(theme)
  }

  const toggleTheme = async () => {
    const newTheme = currentTheme.value === 'dark' ? 'light' : 'dark'
    await setTheme(newTheme)
  }

  watch(currentTheme, (newTheme) => {
    applyTheme(newTheme)
  })

  return {
    currentTheme,
    initTheme,
    setTheme,
    toggleTheme
  }
}